import { getAlertMessageFunction } from '../../../common/Util';

export const getFilteredEducationCodes = detail => {
  if (!detail) return [];

  // 본인(0)이고 장애인이 아닌(1이 아닌) 경우
  if (detail.htm002 === '0' && detail.htm004 !== '1') {
    return ['1', '2', '3', '6', '4', '7'];
  }
  // 본인(0)이고 장애인인(1) 경우
  else if (detail.htm002 === '0' && detail.htm004 === '1') {
    return ['1', '2', '3', '6', '4', '5', '7'];
  }
  // 배우자(1) 또는 직계존속(2)이고 장애인인(1) 경우
  else if ((detail.htm002 === '1' || detail.htm002 === '2') && detail.htm004 === '1') {
    return ['5'];
  }
  // 본인이 아니고(0이 아님) 장애인이 아닌(1이 아닌) 경우
  else if (detail.htm002 !== '0' && detail.htm004 !== '1') {
    return ['2', '3', '6'];
  }
  // 본인이 아니고(0이 아님) 장애인인(1) 경우
  else if (detail.htm002 !== '0' && detail.htm004 === '1') {
    return ['2', '3', '6', '5'];
  }
  return [];
};

export const isValidate = (data, t) => {
  const alertMessage = getAlertMessageFunction();
  const { htm015, htm023, htm072, htm110, htm024, htm073, htm111 } = data;
  let result = {
    result: true,
    flag: 0,
  };

  //교육비 분류를 선택
  if (
    (!htm015 || htm015 == '') &&
    (htm023 > '0' || htm072 > '0' || htm110 > '0' || htm024 > '0' || htm073 > '0' || htm111 > '0')
  ) {
    return {
      message: t('alertMessage.message1'),
      result: false,
      flag: 0,
    };
  }

  //교복비는 중고등생만 해당
  if (htm015 != '3' && (htm072 > '0' || htm073 > '0')) {
    return {
      result: false,
      flag: 1,
      message: t('alertMessage.message2'),
    };
  }

  //교복비의 한도는 50만원
  if (Number(htm072) + Number(htm073) > 500000) {
    return {
      message: t('alertMessage.message3'),
      result: false,
      flag: 2,
    };
  }

  //현장학습비의 한도는 30만원
  if (Number(htm110) + Number(htm111) > 300000) {
    return {
      message: t('alertMessage.message4'),
      result: false,
      flag: 3,
    };
  }

  //현장학습비는 초중고등생만
  if (htm015 != '3' && (htm110 > '0' || htm111 > '0')) {
    return {
      message: t('alertMessage.message5'),
      result: false,
      flag: 4,
    };
  }

  return result;
};
